import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  evaluationAccept: null,
  evaluationAcceptError: "",
  formError: "",
};

export default function EvaluationAcceptReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_EVALUATION_ACCEPT:
      return { ...state, loading: action.payload };
    case actions.GET_EVALUATION_ACCEPT:
      return { ...state, evaluationAccept: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.EVALUATION_ACCEPT_FAIL:
      return { ...state, evaluationAcceptError: action.payload };
    default:
      return state;
  }
}
